import dynamic from "next/dynamic";
import qs from "qs";
import { GetServerSideProps } from "next";

const LandingPage = dynamic(() => import("@/Components/pages/LandingPage"));

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=1800, stale-while-revalidate=59",
    );
  }

  const slug = ctx.params?.slug as string;

  const query = qs.stringify(
    {
      filters: {
        slug: {
          $eq: slug,
        },
      },
      populate: "deep,8",
    },
    {
      encodeValuesOnly: false,
    },
  );

  const apiRes = await fetch(
    `${baseUrl}landing-pages/?${decodeURIComponent(query)}`,
  );
  const apiResData = await apiRes.json();

  const listData = apiResData?.data?.[0]?.attributes;

  if (!listData) {
    return { notFound: true };
  }

  return {
    props: {
      blocksData: listData.blocks ?? null,
      seoData: listData.seo ?? null,
    },
  };
};

interface LandingProps {
  blocksData: any;
  seoData: any;
}

const Landing: React.FC<LandingProps> = ({ blocksData, seoData }) => {
  return <LandingPage blocks={blocksData} seo={seoData} />;
};

export default Landing;
